import gql from 'graphql-tag'

export interface QueryVariables {
  id: string
}

export interface Employee {
  id: string
  staffCode: string
  displayFullName: string
}

export type QueryResult = {
  client: {
    id: number
    procedureStatus: ProcedureStatus
  }
}

interface ProcedureChangeOfficeDatum {
  id: string
  procedureStatusId: string
  beforeOfficeId: string
  afterOfficeId: string
  relocateOn: string
}

export interface ProcedureStatus {
  id: string
  procedureType: string
  dateOn: string
  employee: Employee
  procedureChangeOfficeDatum: ProcedureChangeOfficeDatum
}

export const PROCEDURE_STATUS = gql`
  query procedureStatus($id: ID!) {
    client {
      id
      procedureStatus(procedureStatusId: $id) {
        id
        procedureType
        dateOn
        employee {
          id
          staffCode
          displayFullName
        }
        procedureChangeOfficeDatum {
          id
          procedureStatusId
          beforeOfficeId
          afterOfficeId
          relocateOn
        }
      }
    }
  }
`

export const UPDATE_PROCEDURE_CHANGE_OFFICE_DATUM = gql`
  mutation updateProcedureChangeOfficeDatum($input: UpdateProcedureChangeOfficeDatumInput!) {
    updateProcedureChangeOfficeDatum(input: $input) {
      procedureStatus {
        id
        procedureChangeOfficeDatum {
          id
          procedureStatusId
          beforeOfficeId
          afterOfficeId
          relocateOn
        }
      }
    }
  }
`
